import{ProductVersion as o}from"@gamezop/gzp-frontend-common/types";function n(n){return""===n?"":o[n]}export{n as getProductVersion};
